<template>
  <div id="generate-document">
    <GlobalLoading v-if="isLoading" />
    <div class="document-container">
      <div ref="document">
        <PaktaIntegritasBCE />
        <!-- page break -->
        <div class="html2pdf__page-break" />
        <!--  -->
        <PaktaIntegritasGEMS />
      </div>
    </div>

    <button class="floating-button" @click="exportToPDF">Export to PDF</button>
    <button class="top-floating-button" @click="exportToPDF">
      Export to PDF
    </button>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js'

export default {
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
    PaktaIntegritasBCE: () => import('@/views/PDF/PaktaIntegritasBCE'),
    PaktaIntegritasGEMS: () => import('@/views/PDF/PaktaIntegritasGEMS'),
  },
  data() {
    return {
      isVisible: false,
      isLoading: false,
    }
  },
  methods: {
    getDate() {
      return this.getDate()
    },
    async exportToPDF() {
      this.isVisible = true
      this.isLoading = true
      await html2pdf(this.$refs.document, {
        margin: [0.2, 1],
        filename: 'Dokument Pakta Integritas.pdf',
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 4, dpi: 192, letterRendering: true },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
      })
      this.isVisible = false
      this.isLoading = false
    },
  },
}
</script>
